export const getUrl = (url: string) => {
  return url
    .replace(/\:/g, ' colon ')
    .replace(/\;/g, ' semicolon ')
    .replace(/\//g, ' forward slash ')
    .replace(/\\/g, ' back slash ')
    .replace(/\-/g, ' dash ')
    .replace(/\./g, ' dot ')
    .replace(/\,/g, ' comma ')
    .replace(/\_/g, ' underscore ');
};

export const getLoginCode = (code: string) => {
  return code.split('').join(',').replace('-', ' dash ');
};

/**
 * Return an array of the text showed in screen to transform en tts
 * @param url
 * @returns
 */
export const getAboutTexts = (url: string) => [
  {
    value: 'settings.title-about',
    translate: true,
  },
  {
    value: 'settings.subtitle',
    translate: true,
  },
  {
    value: getUrl(url),
    translate: false,
  },
];

/**
 * Return an array of the text showed in screen to transform en tts
 * @param url
 * @returns
 */
export const getHelpTexts = (url: string) => [
  {
    value: 'settings.title-help',
    translate: true,
  },
  {
    value: 'settings.subtitle',
    translate: true,
  },
  {
    value: getUrl(url),
    translate: false,
  },
];

/**
 * Return an array of the text showed in screen to transform en tts
 * @param url
 * @returns
 */
export const getPrivacyPolicyTexts = (url: string) => [
  {
    value: 'settings.title-privacy-policy',
    translate: true,
  },
  {
    value: 'settings.subtitle',
    translate: true,
  },
  {
    value: getUrl(url),
    translate: false,
  },
];

/**
 * Return an array of the text showed in screen to transform en tts
 * @returns
 */
export const getLogout = () => [
  {
    value: 'settings.sign-out-confirmation',
    translate: true,
  },
];
